<script setup lang="ts">
import {
    faFaceFrown,
    faFaceLaugh,
    faFaceMeh,
    faFaceSmile,
} from '@fortawesome/pro-regular-svg-icons';

export type PointSize = 'large' | 'medium' | 'small';
interface IProps {
    value: number;
    size?: PointSize;
}
const { value, size = 'medium' } = defineProps<IProps>();
const color = computed(() => {
    if (value <= 3.5) {
        return 'var(--yellow-500)';
    } else if (value <= 7) {
        return 'var(--gray-600)';
    } else {
        return 'var(--green-500)';
    }
});
const pointIcon = computed(() => {
    if (!value) {
        return faFaceMeh;
    } else if (value <= 3.5) {
        return faFaceFrown;
    } else if (value <= 6.1) {
        return faFaceMeh;
    } else if (value <= 7) {
        return faFaceSmile;
    } else {
        return faFaceLaugh;
    }
});
</script>

<template>
    <div class="points-container" :style="{ '--color': color }">
        <mr-typography :size class="point" :color weight="700">
            {{ value }}/10
        </mr-typography>
        <mr-icon :icon="pointIcon" :color :size />
    </div>
</template>

<style lang="scss" scoped>
// eslint-disable-next-line vue-scoped-css/require-selector-used-inside
.points-container {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.hide {
        visibility: hidden;
    }

    .point {
        margin-right: 4px;
    }
}
</style>
